<template>
  <div class="document-finder">
    <div>
      <div
        class="mbm"
        v-html="jobs.description"
      />
      <v-client-table
        :id="titleId"
        :ref="titleId"
        :name="titleId"
        :data="jobs"
        :columns="columns"
        :options="options"
      >
        <div
          v-if="planList.length"
          slot="beforeFilter"
          class="multiselect-before-filter"
        >
          <div class="multiselect-container">
            <label
              class="multiselect-label"
              for="pay-plan-multiselect"
            >
              Select a pay plan
            </label>
            <multiselect
              id="pay-plan-multiselect"
              v-model="planValue"
              class="pay-plan-multiselect"
              :options="planList"
              placeholder="Showing all pay plans"
              @input="filterPayPlans"
            />
          </div>
          <div class="multiselect-container">
            <label
              class="multiselect-label"
              for="pay-range-multiselect"
            >
              Select a pay range
            </label>
            <multiselect
              id="pay-range-multiselect"
              v-model="payValue"
              class="pay-range-multiselect"
              :options="payList"
              placeholder="Showing all pay ranges"
              @input="filterPayRanges"
            />
          </div>
          <a
            class="clear-selection"
            tabindex="0"
            @click="clearFilters"
            @keyup.enter="clearFilters"
          >
            Clear selection
          </a>
        </div>
        <div
          :id="row.id"
          slot="step_1"
          slot-scope="{row}"
          v-html="formatMoney(row.step_1)"
        />
        <div
          :id="row.id"
          slot="step_2"
          slot-scope="{row}"
          v-html="formatMoney(row.step_2)"
        />
        <div
          :id="row.id"
          slot="step_3"
          slot-scope="{row}"
          v-html="formatMoney(row.step_3)"
        />
        <div
          :id="row.id"
          slot="step_4"
          slot-scope="{row}"
          v-html="formatMoney(row.step_4)"
        />
        <div
          :id="row.id"
          slot="step_5"
          slot-scope="{row}"
          v-html="formatMoney(row.step_5)"
        />
        <div
          :id="row.id"
          slot="step_6"
          slot-scope="{row}"
          v-html="formatMoney(row.step_6)"
        />
        <div
          :id="row.id"
          slot="step_7"
          slot-scope="{row}"
          v-html="formatMoney(row.step_7)"
        />
        <div
          :id="row.id"
          slot="step_8"
          slot-scope="{row}"
          v-html="formatMoney(row.step_8)"
        />
        <div
          :id="row.id"
          slot="hourly_rate"
          slot-scope="{row}"
          v-html="formatMoney(row.hourly_rate)"
        />
        <div
          slot="beforeTable"
          class="table-info"
          :class="{ hide: !viewMessage}"
        >
          <span><i class="fas fa-info-circle fa-3x" /></span>
          <span class="table-message"><p>These are the results out of a total {{ jobs.length }} records for the search of <strong>{{ searchTerm }}</strong>. Please click the clear filter button to view all records.</p></span>
          <span class="table-button"><button @click="closeMessage"><a>Clear filter</a></button></span>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { Event } from 'vue-tables-2';
window.daterangepicker = require('daterangepicker');


export default {
  name: 'PayRanges',
  components: {
    Multiselect,
  },
  props: {
    jobs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    query: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  data: function() {
    return {
      columns: [ 
        'pay_plan',
        'pay_range',
        'step_1',
        'step_2',
        'step_3',
        'step_4',
        'step_5',
        'step_6',
        'step_7',
        'step_8',
        'hourly_rate',
        'effective_date',
      ],
      options: {
        addSortedClassToCells: true,
        dateColumns: [ 'effective_date' ],
        toMomentFormat: 'MMMM D, YYYY',
        dateFormat: 'MMMM D, YYYY',
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
        perPage: 10,
        pagination: {
          chunk : 3,
        },
        perPageValues: [],
        customFilters: [{
          name: 'filterPayPlans',
          callback: function (row, query) {
            return row.pay_plan == query;
          },
        }, {
          name: 'filterPayQuery',
          callback: function (row, query) {
            return row.pay_range == query;
          },
        }, {
          name: 'filterPayRanges',
          callback: function (row, query) {
            let lowValue = null;
            let highValue = null;
            switch( query ) {
            case '$0 - $20000':
              lowValue = 0;
              highValue = 20000;
              break;
            case '$20001 - $40000':
              lowValue = 20001;
              highValue = 40000;
              break;
            case '$40001 - $60000':
              lowValue = 40001;
              highValue = 60000;
              break;
            case '$60001 - $80000':
              lowValue = 60001;
              highValue = 80000;
              break;
            case '$80001+':
              lowValue = 80001;
              highValue = 1000000;
              break;
            default:
              lowValue = null;
              highValue = null;
            }
            return (
              (row.step_1 >= lowValue && row.step_1 <= highValue ) ||
              (row.step_2 >= lowValue && row.step_2 <= highValue ) ||
              (row.step_3 >= lowValue && row.step_3 <= highValue ) ||
              (row.step_4 >= lowValue && row.step_4 <= highValue ) ||
              (row.step_5 >= lowValue && row.step_5 <= highValue ) ||
              (row.step_6 >= lowValue && row.step_6 <= highValue ) ||
              (row.step_7 >= lowValue && row.step_7 <= highValue ) ||
              (row.step_8 >= lowValue && row.step_8 <= highValue )
            );
          },
        }],
      },
      titleId: 'jobs-table',
      planList: [
        'AFSCME DC33 (0001-0025)',
        'AFSCME DC47 Local 2187 (EP01-EP41)',
        'Non-represented & AFSCME DC47 Local 2186 (N001-N041, CP10-13-A)',
        'Correctional (0038-0049A)',
        'Deputy Sheriff (0050-0059)',
        'Police (FOP) & Prosecution Detective (0201-0299)',
        'Fire (IAFF) (0301-0350)',
        'Hourly & Seasonal (H001-H020)',
        'Half-Time and Hourly Rates Physician & Dentist (EP19-EP40)',
        'Half-Time and Hourly Rates Physician & Dentist (N019-N040)',
      ],
      payList: [ 
        '$0 - $20000',
        '$20001 - $40000',
        '$40001 - $60000',
        '$60001 - $80000',
        '$80001+',
      ],
      payValue: '',
      planValue: '',
      viewMessage: false,
      searchTerm: null,
    };
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init () {
      let vm = this;
      await vm.searchQuery();
    },
    filterPayPlans () {
      let vm  = this;
      if (vm.planValue == "All pay plans") {
        Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayPlans`, null);
      } else {
        Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayPlans`, vm.planValue);
      }
    },
    filterPayRanges () {
      let vm  = this;
      if (vm.payValue == "All pay ranges") {
        Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayRanges`, null);
      } else {
        Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayRanges`, vm.payValue);
      }
    },
    closeMessage () {
      let vm  = this;
      vm.viewMessage = false;
      vm.clearFilters();
    },
    showMessage () {
      let vm  = this;
      vm.viewMessage = true;
    },
    formatMoney( money ) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      if ( money ) {
        return formatter.format(money);
      }
    },
    clearFilters() {
      let vm = this;
      Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayRanges`, null);
      Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayPlans`, null);
      Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayQuery`, null);
      vm.payValue = null;
      vm.planValue = null;
    },
    async searchQuery () {
      let vm = this;
      if(vm.$route.query.q ) {
        vm.searchTerm = vm.$route.query.q;
        vm.showMessage();
        Event.$emit(`vue-tables.${vm.titleId}.filter::filterPayQuery`, vm.searchTerm);
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>